import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'

export default createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/channel',
      name: 'Channel',
      component: () => import('../views/ChannelView.vue')
    },
    {
      path: '/partner',
      name: 'Partner',
      component: () => import('../views/PartnerView.vue')
    }
  ]
})